import React from 'react'
import classNames from 'classnames'

export default function SimpleTableCell({
    children,
    minWidth = 'auto',
    className = ""
}) {

    let classes = typeof className === "string" ? className.split(" ").reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {}) : className;

    const Classes = classNames({
        "relative table-cell flex items-center align-middle h-full border-b border-r border-line last:border-r-0 h-full": true,
        ...classes
    })

    return (
        <div className={Classes} style={{minWidth}}>
            {children}
        </div>
    )
}
